export default {
  menu: {
    add: 'add',
    history: 'history',
    data: 'data',
    greeting: 'hello',
    logout: 'logout',
    notLoggued: 'not logged',
    color: 'color',
    article: 'article',
    order: 'order',
    design: 'design',
    method: 'method',
    code: 'code',
    conveyor: 'conveyor',
    location: 'location',
    delivery: 'delivery',
    refund: 'refund',
    invoice: 'invoice',
    price: 'price',
    articleDefault: 'article default',
    size: 'size',
    user: 'user',
    product: 'product',
    label: 'label',
    labels: 'labels',
    returnAddress: 'return address',
    remission: 'remission',
    tier: 'tier',
    temporaryStock: 'temporary stock',
    orderWholesaler: 'order wholesaler',
    print: 'print',
    login: 'login',
    verification: 'verification',
    connected: 'connected',
    notConnected: 'not connected'
  },
  order: {
    fields: {
      isWholesaler: 'wholesaler',
      isDropshipping: 'dropshipping',
      dni: 'dni',
      name: 'nanme',
      phone: 'phone',
      email: 'email',
      location: 'location',
      department: 'department',
      address: 'address',
      deliveryTime: 'delivery time',
      conveyor: 'conveyor',
      conveyorCost: 'conveyor cost',
      methodPay: 'method pay',
      methodPayCost: 'method pay cost',
      adviser: 'adviser',
      mpCode: 'mi paquete code',
      tip: 'tip',
      codeName: 'code name',
      codePercent: 'discount percent',
      codeValue: 'discount value'
    },
    titles: {
      generalData: 'general data',
      products: 'products',
      observations: 'observations',
      pay: 'pays',
      history: 'history'
    },
    subtitles: {
      total: 'total',
      manuals: 'manuals'
    },
    labels: {
      typeProduct: 'type a product',
      observation: 'observation',
      type: 'type',
      methodPay: 'method pay',
      value: 'value'
    },
    buttons: {
      findProduct: 'find product',
      addObservation: 'add observation',
      check: 'check',
      decline: 'decline',
      approve: 'approve',
      addPay: 'add pay',
      update: 'update',
      save: 'save'
    },
    tables: {
      observation: 'observation',
      type: 'type',
      methodPay: 'method pay',
      state: 'state',
      value: 'value',
      createdAt: 'created at',
      checkedAt: 'checked at',
      actions: 'actions',
      createdBy: 'created by',
      updatedBy: 'updated by',
      updatedAt: 'updated at',
      declined: 'declined',
      approved: 'approved',
      paid: 'paid',
      packed: 'packed',
      sent: 'sent',
      refunded: 'refunded',
      delivery: 'delivery',
      conveyor: 'conveyor',
      tracking: 'tracking'
    },
    options: {
      delivery: 'delivery',
      pay: 'pay',
      product: 'product',
      support: 'support'
    },
    states: {
      created: 'created',
      approved: 'approved',
      declined: 'declined',
      delivered: 'delivered',
      inprogress: 'inprogress',
      refunded: 'refunded'
    }
  }
}



// WEBPACK FOOTER //
// ./src/languages/english.js